var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal-content"},[(_vm.component)?_c(_vm.component,{tag:"component"}):_vm._e(),(_vm.component === undefined)?_c('span',[_vm._v("Not found")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }